import { css } from '@emotion/css';

export const deleteIconSpacing = (marginLeft: number) => css`
  .MuiChip-deleteIcon {
    margin: 0;
    margin-inline-start: ${marginLeft}rem;
  }
`;
